const _getFontSize = (textLength) => {
  const baseFontSize = 6;
  const lengthModifier = 0.06;
  let fontSize = 1.5;
  if (textLength > baseFontSize) {
    fontSize = fontSize - textLength * lengthModifier;
  }
  return `${fontSize}em`;
};

class ProgressCircle {
  constructor(element, options) {
    this._element = element;
    this._options = options;
    this._init();
  }

  _init() {
    const progressText = this._element.querySelector('.progress-text');

    const progressVal = progressText.dataset.progress;
    const totalPercentageVal = progressText.dataset.progressTotal;

    const scaleDigit = 3.76;
    const totalScale = 100;

    const strokeVal = (scaleDigit * totalScale) / totalPercentageVal;

    const circleProgress = this._element.querySelector('.progress-circle-prog');
    circleProgress.style.strokeDasharray = `${progressVal * strokeVal} 999`;

    const boxes = document.querySelectorAll('.progress-text');
    boxes.forEach((box) => {
      box.style.fontSize = _getFontSize(box.textContent.length);
    });
  }
}

export default ProgressCircle;
